import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';

import { ImportLocationProgressStatusSelector } from 'state/progressImportLocations/selectors';
import { useRouter } from 'utils';

import { CreateImportsChannelSubscriptions } from '../ImportsChannel';
import ImportedFileCards from './ImportedFileCards';

const isPageHasImport = pageId => localStorage.getItem(`${pageId}`);

const ImportedFileCardsContainer = (props) => {
  const { imports, refetchDataset } = props;
  const { pageId } = useRouter();
  const dispatch = useDispatch();
  const importInProgress = useSelector(state => ImportLocationProgressStatusSelector(state));
  const activeImportId = importInProgress.id || isPageHasImport(pageId);

  const hasActiveImport = find(imports, ({ percentComplete }) => percentComplete < 100);

  useEffect(() => {
    if (!hasActiveImport || isEmpty(isPageHasImport(pageId))) return;

    imports.forEach(({ id, fileName, percentComplete }) => {
      if (percentComplete !== 100) {
        CreateImportsChannelSubscriptions(id, fileName, dispatch, pageId);
      }
    });
  }, [imports, dispatch, pageId, hasActiveImport]);

  useEffect(() => {
    const handleImportUpdated = (event) => {
      if (String(event.detail.pageId) === String(pageId) && refetchDataset) {
        refetchDataset();
      }
    };

    window.addEventListener('dataset-import-updated', handleImportUpdated);

    return () => {
      window.removeEventListener('dataset-import-updated', handleImportUpdated);
    };
  }, [pageId, refetchDataset]);

  return <ImportedFileCards pageId={pageId} {...importInProgress} id={activeImportId} {...props} />;
};

ImportedFileCardsContainer.propTypes = {
  imports: PropTypes.array.isRequired,
  refetchDataset: PropTypes.func,
  percent: PropTypes.number,
  fileName: PropTypes.string,
};

export default ImportedFileCardsContainer;
